export default __webpack_public_path__ + "static/media/leadBundle3.822e714e.svg";